import { render, staticRenderFns } from "./SelectedFacets.vue?vue&type=template&id=421f44e8&"
import script from "./SelectedFacets.vue?vue&type=script&lang=js&"
export * from "./SelectedFacets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports